import * as cee from '../Common/CeeEnvisionWebComponents';

export function vec3ToString(vec: cee.Vec3Like, numDps = 2) {
  const x = vec.x.toFixed(numDps);
  const y = vec.y.toFixed(numDps);
  const z = vec.z.toFixed(numDps);
  return `${x} ${y} ${z}`;
}

export function stringToVec3(str: string): cee.Vec3Like {
  if (!str) {
    return null as any;
  }

  const parts = str.split(' ');
  if (parts.length !== 3) {
    return null as any;
  }

  const x = parseFloat(parts[0]);
  const y = parseFloat(parts[1]);
  const z = parseFloat(parts[2]);

  if (isNaN(x) || isNaN(y) || isNaN(z)) {
    return null as any;
  }

  return { x, y, z };
}

// Helper to decode URI params
export function getURLParameter(name: string) {
  const regEx = new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.search) || [null, ''];

  if (regEx[1]) {
    return decodeURIComponent(regEx[1].replace(/\+/g, '%20')) || null;
  }

  return '';
}
